/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { MdDangerous } from "react-icons/md";

export function StockExpired() {
  return (
    <>
      <div className={`card card-custom confhistory card-stretch gutter-b`} style={{ height: "120px" }} >
          <div className="card-body d-flex justify-content-center align-items-center">
            <div className="text-white font-weight-bolder text-center font-size-h2 mt-3">Stock Expired</div>
            <div className="bgIcon">
            <MdDangerous />
            </div>
          </div>
      </div>
    </>
  );
}
